// extracted by mini-css-extract-plugin
module.exports = {"logout":"BarDesktop_logout__HgmD3","hamburger":"BarDesktop_hamburger__10rmf","notifications":"BarDesktop_notifications__3M1pV","compte":"BarDesktop_compte__ag5KY"};